import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IconName } from '@panaya/ui/p-icon';
import { ColorName } from '@panaya/ui/styles-to-code';
import { PDialogFooterBtnActionType, PDialogFooterBtnConfig } from './p-dialog-footer-btn-config.interface';

@Component({
    selector: 'p-ok-cancel-dialog',
    template: `
        <p-dialog-container>
            <p-dialog-header
                title="{{ headerText }}"
                [iconName]="headerIcon"
                [iconColor]="headerIconColor ?? 'base-dark'"
                [isSentenceCase]="isSentenceCase"
            ></p-dialog-header>
            <div class="modal-body simple-dialog-body p-dialog-content" [innerHTML]="bodyText"></div>
            <div *ngIf="additionalText" class="modal-body simple-dialog-body p-dialog-content" [innerHTML]="additionalText"></div>
            <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
        </p-dialog-container>
    `,
    styleUrls: ['./p-warning-dialog.component.scss']
})
export class POkCancelDialogComponent implements OnInit {
    @Output() okClick = new EventEmitter<boolean>();
    headerText?: string;
    headerIcon?: IconName;
    headerIconColor?: ColorName;
    isSentenceCase?: boolean = true;
    bodyText?: string;
    additionalText?: string;
    hideCancelButton = false;
    okText?: string;
    cancelText?: string;
    private okButtonActionType?: PDialogFooterBtnActionType;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: POkCancelDialogData,
        private dialogRef: MatDialogRef<boolean>
    ) {}

    ngOnInit(): void {
        this.headerText = this.data.headerText;
        this.headerIcon = this.data.headerIcon;
        this.headerIconColor = this.data.headerIconColor;
        this.isSentenceCase = this.data.isSentenceCase;
        this.bodyText = this.data.bodyText;
        this.additionalText = this.data.additionalText;
        this.okText = this.data.okText;
        this.cancelText = this.data.cancelText;
        this.okButtonActionType = this.data.okButtonActionType;
    }

    onOkClick(): void {
        this.dialogRef.close(true);
    }

    get footerConfig() {
        const config: any = [];
        if (this.additionalText) {
            config.push({
                click: () => this.onOkClick(),
                text: this.okText || 'Actions.ok',
                type: this.okButtonActionType ?? PDialogFooterBtnActionType.Destructive,
                isCamelCase: true
            });
        } else {
            config.push({
                click: () => this.onOkClick(),
                text: this.okText || 'Actions.ok',
                type: this.okButtonActionType
            });
        }
        if (!this.hideCancelButton) {
            config.push(this.buildCancelOption());
        }
        return config;
    }

    private buildCancelOption(): PDialogFooterBtnConfig {
        if (this.cancelText) {
            return {
                type: PDialogFooterBtnActionType.Close,
                text: this.cancelText
            };
        }
        return {
            type: PDialogFooterBtnActionType.Close
        };
    }
}

export interface POkCancelDialogData {
    headerText: string;
    headerIcon?: IconName;
    headerIconColor?: ColorName;
    isSentenceCase?: boolean;
    bodyText: string;
    additionalText?: string;
    hideCancelButton: boolean;
    okText?: string;
    cancelText?: string;
    automationIdPrefix?: string;
    okButtonActionType?: PDialogFooterBtnActionType;
}

export type POkCancelDialogResult = boolean | '';
